const affiliateStatisticsResource = {

    totalPurchases: 'Total purchases',
    totalPurchasesAmount: 'Total purchase amount',
    totalGuacCashback: 'Total Guac cashback',
    totalUserCashback: 'Total User cashback'
}
export default affiliateStatisticsResource;